<style lang="stylus">
    .ft-menu
        background $ft-bgcolor
        border-radius 6px
        height 34px
        display flex
        align-items center
        padding-right 10px

        &.disabled-menu-item
            pointer-events none

        &.check-style
            cursor pointer

        &:not(.active):hover
            background $ft-hover

        &.active
            background $ft-active

        .ft-menuicon
            width 24px
            height 24px
            margin-left 10px
            &.active
                border-radius 6px
                background $ft-active
            svg
                height 24px;
                width 24px;
                &:focus
                    outline: none;
                &.mm-float-topic,&.mm-num,&.mm-theme-color,&.mm-theme-font,
                &.mm-rainbow-color,&.mm-branch-line,&.mm-float-layout,&.float-lineweight,
                &.float-fillcolor-radius,&.branch-line-style,&.table-sizeRow,&.table-sizeCol,
                &.table-function,&.table-none,&.table-noBorder,&.table-allBorder,&.float-import,
                &.float-export,&.gantt-navigation,&.gantt-add-above,&.gantt-add-below,&.gantt-ai-risk,
                &.gantt-ai-progress,&.ai-diagram-selected,&.ai-diagram-page,&.connector-begin,&.connector-end,&.font-path
                    color: var(--svg-color-gray-42-secondary);
                &.mm-pic,&.mm-line-style,&.quick,&.table-deleteTable,,&.table-deleteRow,&.table-deleteCol,
                &.table-border,
                &.table-outsizeBorders,&.table-insideBorders,
                &.table-bottomBorder,&.table-topBorder,&.table-leftBorder,&.table-rightBorder,&.table-horizontalBorder,
                &.table-verticalBorder,&.table-downBorder,&.table-upBorder,&.gantt-ai-total,&.gantt-ai-share,&.editDig
                    color: var(--svg-color-gray-42-secondary);
                    fill: var(--svg-color-gray-75-secondary);
                &.table-margin
                    color: var(--svg-color-gray-42-secondary);
                    fill: var(--svg-color-gray-d0);
                &.delete-quickstyle
                    color: var(--svg-color-gray-42-secondary);
                &.ai-img-replace
                    fill: var(--svg-color-gray-75-secondary);
                    stroke: var(--svg-color-gray-42-secondary);
                &.ai-org-analysis,&.ai-org-diagnosis,&.ai-menu-more,&.ai-flowchart-analyse,&.ai-flowchart-improve,
                &.ai-chart-compare,&.ai-chart-error,&.ai-chart-trend,&.ai-more
                    stroke:var(--svg-color-gray-75-secondary);
                &.table-narrow,&.table-normal-margin,&.table-wide
                    color: var(--svg-color-gray-75-secondary)
                    stroke: var(--svg-color-gray-42-secondary);
                    fill: var(--svg-color-gray-d0);
                &.table-insertLeft,&.table-insertRight,&.table-insertAbove,&.table-insertBelow
                    stroke: var(--svg-color-gray-42-secondary);
                    color: var(--svg-color-gray-75-secondary);
                    fill var(--svg-color-gray-d0)
            svg[class^='org-']
                color: var(--svg-color-gray-42-secondary);
            svg[class^='ai-']:not(.ai-img-replace)
                color: var(--svg-color-gray-42-secondary);
                fill: var(--svg-color-gray-75-secondary);
        .ft-undercolor
            position absolute
            top 25px
            left 14px
            height 2px
            width 16px
            border-radius 2px

        .ft-menucheck
            width 16px
            height 16px
            margin-left 4px

            &.active::before
                line-height 0
                content url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' %3E%3Cpath stroke='%23424242' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round' d='M4 8l2.5 2.5L12 5'/%3E%3C/svg%3E")
                display block
                width 16px
                height 16px

        .ft-menutext
            color var(--text-color-primary)
            font-size 12px
            //max-width 150px
            margin-left 6px
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
            flex-grow 1

        .ft-menuarrow
            height 32px
            width 8px
            display flex
            align-items center
            pointer-events none
            margin-left 10px

            svg
                transform rotate(-90deg)
                width 8px
                height 8px;
                color: var(--svg-color-gray-75-secondary);

            &.hide
                opacity 0
</style>

<template>
    <div
        class="ft-menu"
        v-tippy="{ content: text, placement: placement }"
        :class="{ active: active, 'disabled-menu-item': disable, 'check-style': isChecked }"
        @click="clickMenu"
    >
        <div class="ft-menuicon" v-if="useIcon" :class="{ active: rectChecked && checked }">
            <template v-if="imgIcon && imgIcon.includes('/img/')">
                <img :src="imgIcon" draggable="false" @dragstart.prevent alt="" />
            </template>
            <template v-else>
                <iconSymbol :class="imgIcon" :name="imgIcon" draggable="false" @dragstart.native.prevent />
            </template>
            <div v-if="underColor" class="ft-undercolor" :style="{ background: underColor }"></div>
        </div>
        <div class="ft-menucheck" :class="{ active: checked, 'ft-has-checked-list-item': checked }" v-if="isChecked"></div>
        <p class="ft-menutext">{{ text }}</p>
        <div class="ft-menuarrow" v-if="isExpand" :class="{ hide: hideExpand }">
            <iconSymbol name="float-triangle" draggable="false" @dragstart.native.prevent />
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class FtMenu extends Vue {
        @Prop() imgIcon;
        @Prop() text;
        @Prop() active;
        @Prop({ default: false }) isExpand;
        @Prop({ default: false }) disable;
        @Prop({ default: false }) isChecked;
        @Prop({ default: false }) checked;
        @Prop({ default: false }) rectChecked;
        @Prop({ default: false }) hideExpand;
        @Prop() checkId;
        @Prop({ default: "" }) underColor: string; // 部分图标下方的预览颜色
        @Prop({ default: "left" }) placement;

        get useIcon() {
            return !this.isChecked && this.imgIcon;
        }

        clickMenu() {
            this.$emit("clickMenu", this.checkId);
        }

        created() {}
        mounted() {}
    }
</script>
